import { Breadcrumb } from 'flowbite-react';
import React from 'react';
import { HiHome } from 'react-icons/hi';
import { useNavigate } from 'react-router-dom';

import { mutateProduct } from '@/api/products';
import { toastMsg } from '@/components/Toast';
import ProductForm from '@/features/products/ProductForm';
import { formatCentsToEuro } from '@/helpers/money';
import NavbarSidebar from '@/layouts/NavbarSidebar';

const ProductPageCreate: React.FC = () => {
  const mutate = mutateProduct();
  const navigate = useNavigate();

  const handleCreateProduct = async (
    productDetails: Omit<Api.Product, 'id'>,
  ) => {
    console.log(productDetails);
    await mutate
      .mutateAsync(productDetails)
      .then((response) => {
        toastMsg({ title: 'Producto creado' });
        navigate(`/products/edit/${response.id}`);
      });
  };

  return (
    <NavbarSidebar>
      <div className="block items-center justify-between border-b border-gray-200 bg-white p-4   sm:flex">
        <div className="w-full">
          <Breadcrumb>
            <Breadcrumb.Item href="/">
              <div className="flex items-center gap-x-3">
                <HiHome className="text-xl" />
                <span className="">Inicio</span>
              </div>
            </Breadcrumb.Item>
            <Breadcrumb.Item href="/products">
              Productos
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              Crear Producto
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      <div className="flex flex-col">
        <div className="overflow-x-auto">
          <div className="relative grid grid-cols-1 overflow-y-hidden xl:h-[calc(100vh-4rem)] xl:grid-cols-3">
            <div className="py-6 px-4 xl:sticky xl:mb-0 xl:pb-0">
              <div className="mb-4 rounded-lg bg-white p-4 shadow  sm:p-6 xl:p-8">
                <h1 className="text-xl font-semibold text-gray-900  sm:text-2xl">
                  Informaci&oacute;n del Producto
                </h1>
                <ProductForm
                  callback={handleCreateProduct as never}
                  initialState={{
                    basePrice: formatCentsToEuro(0),
                  }}
                  isLoading={mutate.isLoading}
                />
              </div>
            </div>
            <div className="w-full col-span-2 m-auto mb-5 h-full space-y-6 overflow-hidden overflow-y-auto p-4 lg:pt-6">
              ProductVariations
            </div>
          </div>
        </div>
      </div>
    </NavbarSidebar>
  );
};

export default ProductPageCreate;
